import { getSalonAdminApiBaseUrl } from '../../salon-admin/utils/apiConfig';
import { hqSessionFetchInit } from '../../admin-shared/hqSessionAuth';
import { PORTAL_ID } from './api';

function adminBase() {
  return (getSalonAdminApiBaseUrl() || '').replace(/\/$/, '');
}

function hasPartnerSession() {
  return Boolean(localStorage.getItem('naturals_partner_userId'));
}

/**
 * @param {{ fromDate?: string, toDate?: string, flowType?: string, stylistId?: string }} params
 */
export async function fetchPartnerFlowAnalytics({
  fromDate,
  toDate,
  flowType = 'all',
  stylistId = 'all',
} = {}) {
  const base = adminBase();
  if (!base || !hasPartnerSession()) {
    throw new Error('Not authenticated');
  }
  const qs = new URLSearchParams();
  if (fromDate) qs.set('fromDate', fromDate);
  if (toDate) qs.set('toDate', toDate);
  if (flowType) qs.set('flowType', flowType);
  if (stylistId) qs.set('stylistId', stylistId);

  const res = await fetch(
    `${base}/partner/flow-analytics?${qs.toString()}`,
    hqSessionFetchInit(PORTAL_ID),
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data?.success) {
    throw new Error(data?.error || 'Failed to load flow analytics');
  }
  return data.analytics || {};
}

export const FLOW_FILTERS = [
  { id: 'all', label: 'All flows' },
  { id: 'skin_analysis', label: 'Skin analysis' },
  { id: 'hair_analysis', label: 'Hair analysis' },
  { id: 'hairstyle', label: 'Hairstyle' },
  { id: 'hair_coloring', label: 'Hair coloring' },
];

export function flowTypeLabel(id) {
  return FLOW_FILTERS.find((f) => f.id === id)?.label || id || '—';
}
